// Change Password module

// The goal of this module is to:
// 1. Check if user is authorised
// 2. And if not -> Display Sign In screen instead

export default class ChangePassword implements IDigitalIdentityHubModule {
  public name = "ChangePassword";

  public init(): void { /* No functionality */ }

  public ready(): void {
    janrain.events.onCaptureSessionNotFound.addHandler(function() {
      janrain.events.onCaptureRenderComplete.addHandler(result => {
        if (result.screen === "changePassword") {
          console.log("Access denied. Redirecting to login page.");
          janrain.capture.ui.renderScreen("signIn");
        }
      });
    });
  }
}
